import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {PipelineFragment} from 'pipelines/graphql/PipelineFragment';

import {AnalysisFragment as AnalysisFragmentType} from './__generated/AnalysisFragment';

export const ANALYSIS_FRAGMENT = gql`
  fragment AnalysisFragment on AnalysisNode {
    id
    archiveRecord {
      purpose
    }
    creationContext {
      entryId
      procedureStepExecutionId
      worksheetId
    }
    creator {
      id
      name
    }
    permissions {
      writable
      archivable
      unarchivable
    }
    project {
      id
    }
    folder {
      id
    }
    url
    ... on PipelineInterface {
      ...PipelineFragment
    }
  }
  ${PipelineFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const AnalysisFragment: FragmentWrapper<AnalysisFragmentType> = {
  fragment: ANALYSIS_FRAGMENT,
  fragmentName: 'AnalysisFragment',
};

export const GET_ANALYSIS_QUERY = gql`
  query GetAnalysis($analysisId: StrictString!) @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    analysis(id: $analysisId) {
      ... on AnalysisNode {
        ...AnalysisFragment
      }
      ...InaccessibleInfoGraphQL
    }
  }

  ${AnalysisFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_ANALYSIS_MODIFIED_AT_QUERY = gql`
  query GetAnalysisModifiedAt($analysisId: StrictString!) @skipAudit @engComponent(name: ANALYSIS_TOOL) {
    analysis(id: $analysisId) {
      ... on PipelineInterface {
        id
        modifiedAt
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
